import { MessageSquareIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

export interface AgencyPreviewChatTriggerProps {
  onClick: () => void
  className?: string
}

export const AgencyPreviewChatTrigger: React.FC<AgencyPreviewChatTriggerProps> = ({
  onClick,
  className,
}): ReactNode => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          onClick={onClick}
          className={cn(
            'agency-preview-chat-trigger',
            'relative h-full w-12 rounded-none border-l',
            'flex flex-col items-center justify-center gap-2',
            'bg-muted/30 hover:bg-muted/50',
            'transition-colors duration-200',
            className
          )}
        >
          <MessageSquareIcon className="size-5 text-muted-foreground" />
          <span
            className="agency-preview-chat-trigger-text whitespace-nowrap text-xs font-medium text-muted-foreground"
            style={{
              writingMode: 'vertical-rl',
              textOrientation: 'mixed',
              transform: 'rotate(180deg)',
            }}
          >
            Test in Chat
          </span>
        </Button>
      </TooltipTrigger>
      <TooltipContent side="left">
        <p>Open chat to test this agency</p>
      </TooltipContent>
    </Tooltip>
  )
}

AgencyPreviewChatTrigger.displayName = 'AgencyPreviewChatTrigger'
